export default "__VITE_ASSET__9531f7e9__"